import { useState } from 'react';
import { Input } from '@/ui/components/Input/Input';
import { Button } from '@/ui/components/Button/Button';
import { Icon } from '@/ui/icons/Icon';
import { emailEnvelope } from '@/assets/images/emojis';
import styles from './EmailPage.module.scss';
import { useUser } from '@/features/user';
import { routes } from '@/routes';
import { useNavigate } from 'react-router-dom';
import { useError } from '@/providers/Error';
import { useSubmitEmail } from '../../hooks/useSubmitEmail';

export function EmailPage() {
  const { error } = useError();
  const { user } = useUser();
  const { submitEmail, isLoading } = useSubmitEmail();
  const [email, setEmail] = useState<string | undefined>(user?.email);
  const navigate = useNavigate();

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleContinue = async () => {
    if (await submitEmail(email)) {
      navigate(routes.email.confirmation);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleContinue();
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.header}>
          <img src={emailEnvelope} alt="Email emoji" className={styles.emoji} />
          <h1 className={styles.title}>Email</h1>
        </div>

        <Input
          label="Email"
          value={email}
          autoFocus
          autoComplete="email"
          inputMode="email"
          onChange={handleEmailChange}
          className={styles.emailInput}
          placeholder="robert.vasilescu@gmail.com"
          error={!!error}
          onKeyDown={handleKeyDown}
        />
      </div>

      <div className={styles.bottomSection}>
        <Button
          trackingId="submit_email"
          className={styles.continueButton}
          onClick={handleContinue}
          rightIcon={<Icon name="arrow-right" />}
          text="Continuă"
          loading={isLoading}
        />
      </div>
    </div>
  );
}

export default EmailPage;
